import React from 'react';
import { Menu, Dropdown, Icon, Divider, Badge, Modal, Select, Input, Row, Tag, Table, Form, message, Card, Col, Drawer, Skeleton, Button, List, Empty, Layout } from 'antd';
import FileViewer from 'react-file-viewer';
import '../../scripts/config'
import 'antd/dist/antd.css';
import '../../assets/css/style.css';

let $this;
let store;
const { Header, Sider, Content } = Layout;
class HelpInfo extends React.Component {
    constructor(props) {
        super(props);
        $this = this;
        store = this.props.store;
        this.state = {
            selectMediaItem: {},
        }
    }
    componentDidMount() {

    }
    onError = () => {

    }
    render() {
        const { store } = this.props;
        return (
            <Layout className="gzt-layout" style={{ height: '600px',borderTop:'solid 1px #ccc'}}>
                <Sider className="gzt-sider">
                    <List
                        header={<div>视频清单</div>}
                        bordered
                        size='small'
                        dataSource={global.constants.helpInfo}
                        renderItem={item => (
                            <List.Item onClick={() => { this.setState({ selectMediaItem: item }) }}>
                                {item.title}
                            </List.Item>
                        )}
                    />
                </Sider>
                <Layout>
                    <Header className="gzt-header">
                        <Row>
                            <Col span={8}>
                                {this.state.selectMediaItem.info || ''}
                            </Col>
                        </Row>
                    </Header>
                    <Content className="gzt-content helpInfo">
                        {
                            this.state.selectMediaItem.url ?
                                <FileViewer fileType={this.state.selectMediaItem.mediaType}
                                    filePath={global.constants.address + this.state.selectMediaItem.url}
                                    onError={this.onError}
                                    errorComponent={Error}
                                    unsupportedComponent={Error}
                                /> : <Empty></Empty>
                        }

                    </Content>
                </Layout>
            </Layout>
        );
    }
}
export default HelpInfo;